import { useCallback } from 'react';

const useDownloadCSV = () => {
    const downloadCSV = useCallback((base64, fileName = 'data.csv') => {
        // Convert base64 to raw data
        const csvData = atob(base64);

        // Create a Blob from the decoded base64
        const blob = new Blob([csvData], { type: 'text/csv' });

        // Create an anchor element and trigger download
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;

        // Append the anchor to the document and click it
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the anchor from the document
        document.body.removeChild(downloadLink);
    }, []);

    return downloadCSV;
};

export default useDownloadCSV;